"use client";

import { useTranslations } from "next-intl";
import { useState } from "react";

function ReadMore({
  text,
  maxChars = 100,
}: {
  text: string;
  maxChars?: number;
}) {
  const t = useTranslations("Common");
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  if (text.length <= maxChars) {
    // If text is shorter than maxChars, no need for "Read more"
    return <span>{text}</span>;
  }

  return (
    <span>
      {isExpanded ? (
        text
      ) : (
        <>
          {`${text.slice(0, maxChars)}… `}
          <button
            type="button"
            onClick={toggleReadMore}
            className="text-prune-500 font-medium"
          >
            {t("readMore")}
          </button>
        </>
      )}
    </span>
  );
}

export default ReadMore;
